import { render, staticRenderFns } from "./SupplierBankData.vue?vue&type=template&id=19b608d2&"
import script from "./SupplierBankData.vue?vue&type=script&lang=js&"
export * from "./SupplierBankData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports